module.exports = __webpack_public_path__ + "app-static/img/idcard-badge.8b37277c.png";